"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _styledComponents["default"].div.withConfig({
  displayName: "style",
  componentId: "sc-1kiwgg6-0"
})(["position:relative;input[type=\"color\"]{position:absolute;top:0;left:0;width:60px;height:100%;padding:0;overflow:hidden;}input[type=\"color\"]::-webkit-color-swatch-wrapper{padding:0;}input[type=\"color\"]::-webkit-color-swatch{border:none;}input[type=\"text\"]{padding-left:65px;}"]);

exports["default"] = _default;